import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const MachineDetailsEditModel = {
    headerTitle: i18n.t("servicesystem.common_objects.machine.machine_details"),
    enabledIcon: "mdi-information",
    disabledIcon: "mdi-information-off",
    listItemTextKey: "DisplayName",

    fields: [
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.name"), valuekey: "DisplayName", editable: true, rules: "noempty", defaultValue: "" },
        //{ type: "input", label: i18n.t("servicesystem.common_objects.machine.supplier"), valuekey: "MachineModel.Supplier.Name", editable: false, rules: "", defaultValue: "" },
        //{ type: "input", label: i18n.t("servicesystem.common_objects.machine_type.machine_type"), valuekey: "MachineModel.MachineType.Name", editable: false, rules: "", defaultValue: "" },
        //{ type: "input", label: i18n.t("servicesystem.common_objects.machine.model"), valuekey: "MachineModel.DisplayName", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.location"), valuekey: "Name", editable: true, rules: "noempty", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.facility"), valuekey: "Facility", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.serial_number"), valuekey: "SerialNumber", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.qr_code"), valuekey: "Qrcode", editable: true, rules: "", defaultValue: "" },
        { type: "date", label: i18n.t("servicesystem.common_objects.machine.purchase_date"), valuekey: "BoughtDate", editable: true, rules: "", defaultValue: "" },
        { type: "date", label: i18n.t("servicesystem.common_objects.machine.installation_date"), valuekey: "InstallationDate", editable: true, rules: "", defaultValue: "" },
        { type: "date", label: i18n.t("servicesystem.common_objects.machine.warranty_expires"), valuekey: "WarrantyExpiresDate", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.yearly_budget"), valuekey: "YearlyBudget", editable: true, rules: "", defaultValue: "" },
        { type: "area", label: i18n.t("servicesystem.common_objects.machine.note"), valuekey: "Note", editable: true, rules: "", defaultValue: "" },

        { type: "switch", label: "servicesystem.common_objects.machine.active", valuekey: "IsActive", editable: "onlyedit", defaultValue: true },
    ],

    methods: {
        async save(machine) {
            return clientAPI.methods.createMachine(machine);
        },
        async create(newmachine) {
            return clientAPI.methods.changeMachine(newmachine);
        },
    }
}

export default MachineDetailsEditModel;